export default "__VITE_ASSET__DvJt6J$I__"